export const text = {
  login: 'Login',
  pageTitle: 'Login',
};
